import { render } from "./WelcomeText.vue?vue&type=template&id=55e59496&scoped=true"
import script from "./WelcomeText.vue?vue&type=script&lang=js"
export * from "./WelcomeText.vue?vue&type=script&lang=js"

import "./WelcomeText.vue?vue&type=style&index=0&id=55e59496&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e59496"]])

export default __exports__